<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'all'">
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>Patient Name</th>
        <th>Time</th>
      </tr>
      <tr
        class="td"
        *ngFor="let app of data"
        (click)="view(app)"
        style="cursor: pointer"
      >
        <td>{{ app.Title }}</td>
        <td>
          {{ app.ScheduleDate | date }}
          <span style="padding-left: 10px; color: red">{{
            app.ScheduleTime
          }}</span>
          <!-- <button mat-raised-button color="primary" (click)="view(app)">
            Edit
          </button> -->
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>

  <div *ngSwitchCase="'view'">
    <div class="post">
      <div class="name">
        <table border="0">
          <tbody>
            <tr style="border: 0">
              <td style="border: 0; padding: 0">Patient Name :</td>
              <td style="border: 0; padding: 0">{{ app.Title }}</td>
            </tr>
            <tr style="border: 0">
              <td style="border: 0; padding: 0">Patient Email :</td>
              <td style="border: 0; padding: 0">{{ app.UserEmail }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Title :</td>
              <td style="border: 0; padding: 0">{{ details.title }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Sex :</td>
              <td style="border: 0; padding: 0">{{ details?.sex }}</td>
            </tr>

            <tr>
              <td style="border: 0; padding: 0">Marital Status :</td>
              <td style="border: 0; padding: 0">
                {{ details?.maritalStatus }}
              </td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Date of Birth :</td>
              <td style="border: 0; padding: 0">{{ details?.DOB | date }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Address :</td>
              <td style="border: 0; padding: 0">{{ details?.address }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Comment :</td>
              <td style="border: 0; padding: 0">{{ details?.comment }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Occupatiobn :</td>
              <td style="border: 0; padding: 0">{{ details?.occupatiobn }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">No Of Children :</td>
              <td style="border: 0; padding: 0">{{ details?.noOfChildren }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Phone Number :</td>
              <td style="border: 0; padding: 0">{{ details?.number }}</td>
            </tr>
            <tr>
              <td style="border: 0; padding: 0">Ref Dr :</td>
              <td style="border: 0; padding: 0">{{ details?.refDrs }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="services">
        <div class="all">
          <div class="table">
            <div
              class="service"
              (click)="deleteItem(service.service_id)"
              *ngFor="let service of app.AppointmentDetails"
            >
              {{ service.ItemOfServiceName }}
            </div>
          </div>
        </div>
      </div>
      <div class="bot">
        <button mat-raised-button color="primary" (click)="back()">back</button>
      </div>
    </div>
  </div>
</div>
